import { reactive } from 'vue'
import { api } from './api'

const guestLanguageStorageKey = 'next-reports-guest-language'
const supportedLanguages = new Set(['uk', 'ru', 'en'])

function readGuestLanguage() {
  try {
    const savedLanguage = window.localStorage.getItem(guestLanguageStorageKey)
    return supportedLanguages.has(savedLanguage) ? savedLanguage : 'uk'
  } catch {
    return 'uk'
  }
}

export const session = reactive({
  initialized: false,
  user: null,
  guestLanguage: readGuestLanguage(),
})

export function changeGuestLanguage(language) {
  if (!supportedLanguages.has(language)) return
  session.guestLanguage = language
  try {
    window.localStorage.setItem(guestLanguageStorageKey, language)
  } catch {
    // The login screen remains usable when browser storage is unavailable.
  }
}

export async function restoreSession() {
  try {
    const result = await api('/auth/me')
    session.user = result.user
  } catch (error) {
    if (error.status !== 401) throw error
    session.user = null
  } finally {
    session.initialized = true
  }
}

export async function signIn(username, password) {
  const result = await api('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  })
  session.user = result.user
  session.initialized = true
  return result.user
}

export async function signOut() {
  await api('/auth/logout', { method: 'POST' })
  session.user = null
  session.initialized = true
}

export async function changeOwnPassword(currentPassword, newPassword) {
  const result = await api('/auth/change-password', {
    method: 'POST',
    body: JSON.stringify({ currentPassword, newPassword }),
  })
  session.user = result.user
  return result.user
}

export async function changeReportLanguage(language) {
  const result = await api('/preferences/report-language', {
    method: 'PUT',
    body: JSON.stringify({ language }),
  })
  session.user = result.user
  return result.user
}
